import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { ZERO } from '@morpho-org/dapp-core';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { formatters, getDigitsFromPriceAndAmount } from '@morpho-org/ui-v6/utils';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo } from 'react';
interface SelectTokenInputMaxProps {
  isLoading?: boolean;
  token: InterfaceToken;
  maxValue?: bigint | null;
  disabled?: boolean;
  onMaxClick?(): void;
}
const SelectTokenInputMax = t0 => {
  const $ = _c(21);
  const {
    isLoading,
    token,
    maxValue,
    disabled,
    onMaxClick
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-[26px] w-[112px]" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== maxValue || $[2] !== token.decimals || $[3] !== token.price || $[4] !== token.symbol) {
    t1 = formatters.short.unit(token.symbol).digits(getDigitsFromPriceAndAmount(token.price, maxValue)).trailingZero(!maxValue).of(maxValue ?? ZERO, token.decimals);
    $[1] = maxValue;
    $[2] = token.decimals;
    $[3] = token.price;
    $[4] = token.symbol;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <TooltipTrigger asChild={true}><span className="text-3xs text-secondary-foreground max-w-[300px] truncate whitespace-nowrap">{t1}</span></TooltipTrigger>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== maxValue || $[9] !== token.decimals || $[10] !== token.symbol) {
    t3 = !!maxValue && <TooltipContent>{formatters.short.unit(token.symbol).digits(8).trailingZero(false).of(maxValue ?? ZERO, token.decimals)}</TooltipContent>;
    $[8] = maxValue;
    $[9] = token.decimals;
    $[10] = token.symbol;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <Tooltip>{t2}{t3}</Tooltip>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = disabled || !maxValue;
  let t6;
  if ($[15] !== onMaxClick || $[16] !== t5) {
    t6 = <Button variant="secondary" size="sm" className="h-[26px]" disabled={t5} onClick={onMaxClick}>MAX</Button>;
    $[15] = onMaxClick;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t6) {
    t7 = <div className="gap-xs flex flex-row items-center">{t4}{t6}</div>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default memo(SelectTokenInputMax);